// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon[data-v-02f76f40] {\n  margin-right: 16px;\n}\nvwc-list[data-v-02f76f40] {\n  --mdc-list-vertical-padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
